export class EmailNotificationEvent {
  toEmailAddress: string | string[];
  subject: string;
  message: string;
  ccEmailAddress?: string | string[];

  constructor({
    toEmailAddress,
    subject,
    message,
    ccEmailAddress,
  }: EmailNotificationEvent) {
    this.subject = subject;
    this.toEmailAddress = toEmailAddress;
    this.message = message;
    this.ccEmailAddress = ccEmailAddress;
  }
}
